import React, { Component } from "react";
import {
  Container,
  Card,
  CardHeader,
  Button,
  CardBody,
  FormGroup,
  Label,
  Row,
  Col,
  Input,
} from "reactstrap";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Select from "react-select";
import moment from "moment";
// import DefaultImg from "../../../assets/images/product/Default_img.jpg";
import {
  getUserLocations,
  getUserSubLocations,
  getUserDepartment,
} from "../../../store/Mini/actions";
import {
  getMRreportslist,
  MRreportslistSuccessful,
  reportTypeCheck,
  SetParams,
  ReportsChangeValue,
  ReportsSelecteChangeValue,
} from "../../../store/Reports/actions";

var date = new Date(),
  y = date.getFullYear(),
  m = date.getMonth();
class MRReports extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.ReportsChangeHandeler = this.ReportsChangeHandeler.bind(this);
  }
  MiStatusChoice = [
    { label: "Pending", value: 1 },
    { label: "Waiting for Stock", value: 2 },
    { label: "MI In Progres", value: 3 },
    { label: "Material Issued", value: 4 },
    { label: "Closed", value: 5 },

  ];

  componentDidMount() {
    this.props.getUserLocations();
    this.props.getUserDepartment();
    this.props.SetParams({});
  }
  ReportsChangeHandeler(e) {
    this.props.ReportsChangeValue({
      key: e.target.name,
      value: e.target.value,
    });
    if (this.props.reportType === "document") {
      this.props.getMRreportslist({
        ...this.props.params,
        [e.target.name]: e.target.value,
      });
    }
  }
  SelecteChangeValue({ key, label, key2, value }) {
    this.props.ReportsSelecteChangeValue({
      key,
      label,
      key2,
      value,
    });
    if (this.props.reportType === "document") {
      this.props.getMRreportslist({
        ...this.props.params,
        [key2]: value,
      });
    }
  }

  reportType(e) {
    this.props.reportTypeCheck({ value: e.target.value });

    this.props.MRreportslistSuccessful([]);
    if (e.target.value === "document") {
      this.props.getMRreportslist({
        ...this.props.params,
        start_date:
          this.props.params.start_date == null ||
          this.props.params.start_date === ""
            ? moment(new Date(y, m, 1)).format("YYYY-MM-DD")
            : this.props.params.start_date,
        end_date:
          this.props.params.end_date == null ||
          this.props.params.end_date === ""
            ? moment(new Date()).format("YYYY-MM-DD")
            : this.props.params.end_date,
      });
    }
  }
  reportCheck(e) {
    this.props.ReportsChangeValue({
      key: "action",
      value: e.target.value,
    });
  }
  render() {
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            <Row>
              <Col md={12}>
                <Card>
                  <CardHeader className="bg-transparent border-bottom ">
                    <Link
                      to="/reports"
                      className="action-icon text-primary mr-2"
                    >
                      <i className="mdi mdi-arrow-left-bold-circle-outline font-size-20"></i>
                    </Link>
                    <h5 className="card-title-18 pt-2 d-inline-block">
                      Material Request Report
                    </h5>
                  </CardHeader>
                  <CardBody className="pt-1">
                    <Row className="p-1">
                      <Col md={12}>
                        <Card className="p-1">
                          <CardBody className="pt-1">
                            <Row>
                              <Col md={3} className="mb-0">
                                <FormGroup className="mb-0 pb-0">
                                  <Label
                                    htmlFor="validationFromDate"
                                    className="col-form-label"
                                  >
                                    From Date:
                                  </Label>

                                  <Input
                                    className="mb-0 form-control "
                                    type="date"
                                    value={
                                      this.props.params.start_date == null ||
                                      this.props.params.start_date === ""
                                        ? moment(new Date(y, m, 1)).format(
                                            "YYYY-MM-DD"
                                          )
                                        : this.props.params.start_date
                                    }
                                    onChange={(e) => {
                                      this.ReportsChangeHandeler(e);
                                    }}
                                    id="CProduct-Name-text-input"
                                    name="start_date"
                                    placeholder="select Date"
                                    max={moment(new Date()).format(
                                      "YYYY-MM-DD"
                                    )}
                                  />
                                </FormGroup>
                              </Col>
                              <Col md={3} className="mb-0">
                                <FormGroup className="mb-0 pb-0">
                                  <Label
                                    htmlFor="validationToDate"
                                    className="mb-0 col-form-label"
                                  >
                                    To Date:
                                  </Label>

                                  <Input
                                    className="mb-0 form-control "
                                    type="date"
                                    value={
                                      this.props.params.end_date == null ||
                                      this.props.params.end_date === ""
                                        ? moment(new Date()).format(
                                            "YYYY-MM-DD"
                                          )
                                        : this.props.params.end_date
                                    }
                                    onChange={(e) => {
                                      this.ReportsChangeHandeler(e);
                                    }}
                                    id="CProduct-Name-text-input"
                                    name="end_date"
                                    placeholder="select Date"
                                    disabled={
                                      this.props.params.start_date === ""
                                        ? true
                                        : false
                                    }
                                    min={this.props.params.start_date == null ||
                                      this.props.params.start_date === ""
                                        ? moment(new Date(y, m, 1)).format(
                                            "YYYY-MM-DD"
                                          )
                                        : moment(this.props.params.start_date).format(
                                          "YYYY-MM-DD"
                                        )}
                                    max={moment(new Date()).format(
                                      "YYYY-MM-DD"
                                    )}
                                  />
                                </FormGroup>
                              </Col>
                              <Col md={3}>
                                <FormGroup className="mb-0">
                                  <Label
                                    htmlFor="Location-selection"
                                    className="col-form-label"
                                  >
                                    Locations :
                                  </Label>

                                  <Select
                                    id="Department-selection"
                                    name="Department-selection"
                                    classNamePrefix="select2-selection"
                                    menuPortalTarget={document.body}
                                    styles={{
                                      menuPortal: (base) => ({
                                        ...base,
                                        zIndex: 9999,
                                      }),
                                    }}
                                    options={this.props.userLocation.map(
                                      (item, index) => ({
                                        label: item.name,
                                        value: item.id,
                                      })
                                    )}
                                    value={{
                                      label:
                                        this.props.Reportdata?.locationlabel,
                                      value: this.props.params?.location,
                                    }}
                                    onChange={(e) => {
                                      this.props.getUserSubLocations(e.value);
                                      this.SelecteChangeValue({
                                        key: "locationlabel",
                                        label: e.label,
                                        key2: "location",
                                        value: e.value,
                                      });
                                    }}
                                  />
                                </FormGroup>
                              </Col>
                              <Col md={3}>
                                <FormGroup className="mb-0">
                                  <Label
                                    htmlFor="Department-selection"
                                    className="col-form-label"
                                  >
                                    Sub Location :
                                  </Label>

                                  <Select
                                    id="Department-selection"
                                    name="Department-selection"
                                    classNamePrefix="select2-selection"
                                    isDisabled={
                                      this.props.params.location == null ||
                                      this.props.params.location === ""
                                        ? true
                                        : false
                                    }
                                    menuPortalTarget={document.body}
                                    styles={{
                                      menuPortal: (base) => ({
                                        ...base,
                                        zIndex: 9999,
                                      }),
                                    }}
                                    options={this.props.usersubLocation.map(
                                      (item, index) => ({
                                        label: item.name,
                                        value: item.id,
                                      })
                                    )}
                                    value={{
                                      label:
                                        this.props.Reportdata
                                          ?.usersubLocationlabel,
                                      value: this.props.params?.sublocation,
                                    }}
                                    onChange={(e) => {
                                      this.SelecteChangeValue({
                                        key: "usersubLocationlabel",
                                        label: e.label,
                                        key2: "sublocation",
                                        value: e.value,
                                      });
                                    }}
                                  />
                                </FormGroup>
                              </Col>
                              <Col md={3}>
                                <FormGroup className="mb-0">
                                  <Label
                                    htmlFor="UserDepartment-selection"
                                    className="col-form-label"
                                  >
                                    User Department :
                                  </Label>

                                  <Select
                                    id="UserDepartment-selection"
                                    name="UserDepartment-selection"
                                    classNamePrefix="select2-selection"
                                    menuPortalTarget={document.body}
                                    styles={{
                                      menuPortal: (base) => ({
                                        ...base,
                                        zIndex: 9999,
                                      }),
                                    }}
                                    options={this.props.userDeparment.map(
                                      (item, index) => ({
                                        label: item.name,
                                        value: item.id,
                                      })
                                    )}
                                    value={{
                                      label:
                                        this.props.Reportdata
                                          ?.userdepartmentlabel,
                                      value: this.props.params?.userdepartment,
                                    }}
                                    onChange={(e) => {
                                      this.SelecteChangeValue({
                                        key: "userdepartmentlabel",
                                        label: e.label,
                                        key2: "userdepartment",
                                        value: e.value,
                                      });
                                    }}
                                  />
                                </FormGroup>
                              </Col>
                              <Col md={3}>
                                <FormGroup>
                                  <Label
                                    htmlFor="mistatus"
                                    className="col-form-label "
                                  >
                                    MI Status
                                  </Label>
                                  <Select
                                    id="mistatus"
                                    name="mistatus"
                                    classNamePrefix="select2-selection"
                                    options={[
                                      { label: "Pending", value: 1 },
                                      { label: "Waiting for Stock", value: 2 },
                                      { label: "MI In Progres", value: 3 },
                                      { label: "Material Issued", value: 4 },
                                      { label: "Closed", value: 5 },
                                    ].map((item) => ({
                                      label: item.label,
                                      value: item.value,
                                    }))}
                                    value={{
                                      label:
                                        this.props.Reportdata
                                          ?.mistatus_label == null
                                          ? "Select MI Status Type"
                                          : this.props.Reportdata
                                              ?.mistatus_label,
                                      value:
                                        this.props.Reportdata
                                          ?.mistatus,
                                    }}
                                    onChange={(e) => {
                                      this.SelecteChangeValue({
                                        key: "mistatus_label",
                                        label: e.label,
                                        key2: "mistatus",
                                        value: e.value,
                                      });
                                    }}
                                  />
                                </FormGroup>
                              </Col>
                              <Col md={3}>
                                <FormGroup>
                                  <Label
                                    htmlFor="pistatus"
                                    className="col-form-label "
                                  >
                                    PI Status
                                  </Label>
                                  <Select
                                    id="pistatus"
                                    name="pistatus"
                                    classNamePrefix="select2-selection"
                                    options={[
                                      { label: "Pending", value: 1 },
                                      { label: "PI In Progress", value: 2 },
                                      { label: "Purchase Indent", value: 3 },
                                    ].map((item) => ({
                                      label: item.label,
                                      value: item.value,
                                    }))}
                                    value={{
                                      label:
                                        this.props.Reportdata
                                          ?.pistatus_label == null
                                          ? "Select PI Status Type"
                                          : this.props.Reportdata
                                              ?.pistatus_label,
                                      value:
                                        this.props.Reportdata
                                          ?.pistatus,
                                    }}
                                    onChange={(e) => {
                                      this.SelecteChangeValue({
                                        key: "pistatus_label",
                                        label: e.label,
                                        key2: "pistatus",
                                        value: e.value,
                                      });
                                    }}
                                  />
                                </FormGroup>
                              </Col>
                              <Col md={3}>
                                <FormGroup>
                                  <Label
                                    htmlFor="mrstatus"
                                    className="col-form-label "
                                  >
                                    MR Status
                                  </Label>
                                  <Select
                                    id="mrstatus"
                                    name="mrstatus"
                                    classNamePrefix="select2-selection"
                                    options={[
                                      { label: "Pending", value: 1 },
                                      { label: "HOD(U) Approved", value: 3 },
                                      { label: "HOD(U) Rejected", value: 4 },
                                    ].map((item) => ({
                                      label: item.label,
                                      value: item.value,
                                    }))}
                                    value={{
                                      label:
                                        this.props.Reportdata
                                          ?.mrstatus_label == null
                                          ? "Select MR Status Type"
                                          : this.props.Reportdata
                                              ?.mrstatus_label,
                                      value:
                                        this.props.Reportdata
                                          ?.mrstatus,
                                    }}
                                    onChange={(e) => {
                                      this.SelecteChangeValue({
                                        key: "mrstatus_label",
                                        label: e.label,
                                        key2: "mrstatus",
                                        value: e.value,
                                      });
                                    }}
                                  />
                                </FormGroup>
                              </Col>
                              {/* <Col md={3}>
                                <FormGroup className="mb-0">
                                  <Label
                                    htmlFor="MRStatus-selection"
                                    className="col-form-label"
                                  >
                                    MR Status:
                                  </Label>

                                  <Select
                                    id="MRStatus-selection"
                                    name="MRStatus-selection"
                                    classNamePrefix="select2-selection"
                                    menuPortalTarget={document.body}
                                    styles={{
                                      menuPortal: (base) => ({
                                        ...base,
                                        zIndex: 9999,
                                      }),
                                    }}
                                    options={mrStatus}
                                    value={{
                                      label: this.props.Reportdata?.MR,
                                      value: this.props.params?.sublocation,
                                    }}
                                    onChange={(e) => {
                                      this.SelecteChangeValue({
                                        key: "usersubLocationlabel",
                                        label: e.label,
                                        key2: "sublocation",
                                        value: e.value,
                                      });
                                    }}
                                  />
                                </FormGroup>
                              </Col> */}
                              <Col
                                md={3}
                                className="mt-1 text-center font-size-14"
                              >
                                <div className="mb-1">
                                  <Label>&nbsp;</Label>
                                </div>
                                <div className="border p-2">
                                  <div className="radio d-inline-block mr-5">
                                    <Input
                                      type="radio"
                                      value="list"
                                      name="reportType"
                                      checked={
                                        // true
                                        this.props.reportType === "list"
                                          ? true
                                          : false
                                      }
                                      onClick={(e) => this.reportType(e)}
                                    />
                                    List
                                  </div>
                                  <div className="radio d-inline-block">
                                    <Input
                                      type="radio"
                                      value="document"
                                      name="reportType"
                                      checked={
                                        this.props.reportType === "document"
                                          ? true
                                          : false
                                      }
                                      onClick={(e) => this.reportType(e)}
                                    />
                                    Document
                                  </div>
                                </div>
                              </Col>
                              {this.props.reportType === "document" && (
                                <Col md={3}>
                                  <FormGroup className="mb-0">
                                    <Label
                                      htmlFor="MR_Code-selection"
                                      className="col-form-label"
                                    >
                                      MR Code :
                                    </Label>

                                    <Select
                                      id="MR_Code-selection"
                                      name="MR_Code-selection"
                                      classNamePrefix="select2-selection"
                                      menuPortalTarget={document.body}
                                      styles={{
                                        menuPortal: (base) => ({
                                          ...base,
                                          zIndex: 9999,
                                        }),
                                      }}
                                      options={this.props.MR_ReportData.map(
                                        (item, index) => ({
                                          label: item.code,
                                          value: item.id,
                                        })
                                      )}
                                      value={{
                                        label:
                                          this.props.Reportdata?.MRCodelabel,
                                        value: this.props.params?.MRId,
                                      }}
                                      onChange={(e) => {
                                        this.SelecteChangeValue({
                                          key: "MRCodelabel",
                                          label: e.label,
                                          key2: "MRId",
                                          value: e.value,
                                        });
                                      }}
                                    />
                                  </FormGroup>
                                </Col>
                              )}
                            </Row>

                            <Row>
                              <Col md={12} className="mt-1">
                                <div className="float-right pt-1">
                                  {this.props.reportType === "document" && (
                                    <Link
                                      to={
                                        "/mrreportdoc/" + this.props.params.MRId
                                      }
                                    >
                                      <Button
                                        block
                                        type="button"
                                        color="primary"
                                        disabled={
                                          this.props.params.MRId == null ||
                                          this.props.params.MRId === ""
                                            ? true
                                            : false
                                        }
                                        className="waves-effect waves-light"
                                      >
                                        Generate Report
                                      </Button>
                                    </Link>
                                  )}

                                  {this.props.reportType === "list" && (
                                    <Link to="/mrreportlist">
                                      <Button
                                        block
                                        type="button"
                                        color="primary"
                                        className="waves-effect waves-light"
                                      >
                                        Generate Report
                                      </Button>
                                    </Link>
                                  )}
                                </div>
                              </Col>
                            </Row>
                            {/* </div> */}
                          </CardBody>
                        </Card>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  const { userLocation, userDeparment, usersubLocation } = state.Mini;

  const { params, reportType, Reportdata, MR_ReportData } = state.reports;
  return {
    userLocation,
    userDeparment,
    usersubLocation,
    reportType,
    params,
    Reportdata,
    MR_ReportData,
    //-------
  };
};

export default connect(mapStatetoProps, {
  getUserLocations,
  getUserSubLocations,
  getUserDepartment,
  getMRreportslist,
  reportTypeCheck,
  SetParams,
  ReportsChangeValue,
  ReportsSelecteChangeValue,
  MRreportslistSuccessful,
})(MRReports);
